import type { IAppConfigState } from './interfaces';
import { readCachedAppConfig } from './storage';

const cachedConfig = readCachedAppConfig();

export const initState: IAppConfigState = {
  calendar: {
    upperBound: cachedConfig?.calendar?.upperBound || null,
  },
  source: cachedConfig?.source || null,
  FetchAppConfigAsyncStatus: 'IDLE',
  error: null,
  hydratedFromCache: Boolean(cachedConfig),
};
